// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/server/v1/dataplaneworkflows.proto (package chalk.server.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { JobQueueKind, JobQueueState } from "./dataplanejobqueue_pb";
import { file_chalk_server_v1_dataplanejobqueue } from "./dataplanejobqueue_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/server/v1/dataplaneworkflows.proto.
 */
export const file_chalk_server_v1_dataplaneworkflows: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_permissions, file_chalk_server_v1_dataplanejobqueue, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.server.v1.WorkflowExecution
 */
export type WorkflowExecution = Message<"chalk.server.v1.WorkflowExecution"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 2;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: string environment_id = 3;
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 4;
   */
  deploymentId: string;

  /**
   * @generated from field: chalk.server.v1.WorkflowKind kind = 5;
   */
  kind: WorkflowKind;

  /**
   * @generated from field: chalk.server.v1.WorkflowExecutionStatus status = 6;
   */
  status: WorkflowExecutionStatus;

  /**
   * @generated from field: optional string branch_name = 7;
   */
  branchName?: string;

  /**
   * @generated from field: optional string mainline_deployment_id = 8;
   */
  mainlineDeploymentId?: string;

  /**
   * @generated from field: optional string agent_id = 9;
   */
  agentId?: string;

  /**
   * @generated from field: optional google.protobuf.Struct meta_data = 10;
   */
  metaData?: JsonObject;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp finalized_at = 12;
   */
  finalizedAt?: Timestamp;

  /**
   * @generated from field: repeated string tags = 13;
   */
  tags: string[];

  /**
   * @generated from field: repeated string required_resolver_tags = 14;
   */
  requiredResolverTags: string[];
};

/**
 * Describes the message chalk.server.v1.WorkflowExecution.
 * Use `create(WorkflowExecutionSchema)` to create a new message.
 */
export const WorkflowExecutionSchema: GenMessage<WorkflowExecution> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 0);

/**
 * @generated from message chalk.server.v1.GetDataPlaneWorkflowRequest
 */
export type GetDataPlaneWorkflowRequest = Message<"chalk.server.v1.GetDataPlaneWorkflowRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.server.v1.GetDataPlaneWorkflowRequest.
 * Use `create(GetDataPlaneWorkflowRequestSchema)` to create a new message.
 */
export const GetDataPlaneWorkflowRequestSchema: GenMessage<GetDataPlaneWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 1);

/**
 * @generated from message chalk.server.v1.GetDataPlaneWorkflowResponse
 */
export type GetDataPlaneWorkflowResponse = Message<"chalk.server.v1.GetDataPlaneWorkflowResponse"> & {
  /**
   * @generated from field: chalk.server.v1.WorkflowExecution workflow = 1;
   */
  workflow?: WorkflowExecution;
};

/**
 * Describes the message chalk.server.v1.GetDataPlaneWorkflowResponse.
 * Use `create(GetDataPlaneWorkflowResponseSchema)` to create a new message.
 */
export const GetDataPlaneWorkflowResponseSchema: GenMessage<GetDataPlaneWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 2);

/**
 * @generated from message chalk.server.v1.ListDataPlaneWorkflowsRequest
 */
export type ListDataPlaneWorkflowsRequest = Message<"chalk.server.v1.ListDataPlaneWorkflowsRequest"> & {
  /**
   * @generated from field: string environment_id = 1 [deprecated = true];
   * @deprecated
   */
  environmentId: string;

  /**
   * @generated from field: string deployment_id = 2;
   */
  deploymentId: string;

  /**
   * @generated from field: chalk.server.v1.WorkflowKind kind = 3;
   */
  kind: WorkflowKind;

  /**
   * @generated from field: chalk.server.v1.WorkflowExecutionStatus status = 4;
   */
  status: WorkflowExecutionStatus;

  /**
   * @generated from field: int32 limit = 5;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 6 [deprecated = true];
   * @deprecated
   */
  offset: number;

  /**
   * @generated from field: string cursor = 9;
   */
  cursor: string;

  /**
   * @generated from field: optional string id_filter = 7;
   */
  idFilter?: string;

  /**
   * @generated from field: repeated string tags_filter = 8;
   */
  tagsFilter: string[];
};

/**
 * Describes the message chalk.server.v1.ListDataPlaneWorkflowsRequest.
 * Use `create(ListDataPlaneWorkflowsRequestSchema)` to create a new message.
 */
export const ListDataPlaneWorkflowsRequestSchema: GenMessage<ListDataPlaneWorkflowsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 3);

/**
 * @generated from message chalk.server.v1.ListDataPlaneWorkflowsResponse
 */
export type ListDataPlaneWorkflowsResponse = Message<"chalk.server.v1.ListDataPlaneWorkflowsResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.WorkflowExecution workflows = 1;
   */
  workflows: WorkflowExecution[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: string cursor = 3;
   */
  cursor: string;
};

/**
 * Describes the message chalk.server.v1.ListDataPlaneWorkflowsResponse.
 * Use `create(ListDataPlaneWorkflowsResponseSchema)` to create a new message.
 */
export const ListDataPlaneWorkflowsResponseSchema: GenMessage<ListDataPlaneWorkflowsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 4);

/**
 * @generated from message chalk.server.v1.GetWorkflowGraphRequest
 */
export type GetWorkflowGraphRequest = Message<"chalk.server.v1.GetWorkflowGraphRequest"> & {
  /**
   * @generated from field: string workflow_execution_id = 1;
   */
  workflowExecutionId: string;
};

/**
 * Describes the message chalk.server.v1.GetWorkflowGraphRequest.
 * Use `create(GetWorkflowGraphRequestSchema)` to create a new message.
 */
export const GetWorkflowGraphRequestSchema: GenMessage<GetWorkflowGraphRequest> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 5);

/**
 * @generated from message chalk.server.v1.JobQueueRowSummaryForWorkflows
 */
export type JobQueueRowSummaryForWorkflows = Message<"chalk.server.v1.JobQueueRowSummaryForWorkflows"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string job_name = 2;
   */
  jobName: string;

  /**
   * @generated from field: chalk.server.v1.JobQueueState state = 3;
   */
  state: JobQueueState;

  /**
   * @generated from field: int64 job_index = 4;
   */
  jobIndex: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp finalized_at = 8;
   */
  finalizedAt?: Timestamp;
};

/**
 * Describes the message chalk.server.v1.JobQueueRowSummaryForWorkflows.
 * Use `create(JobQueueRowSummaryForWorkflowsSchema)` to create a new message.
 */
export const JobQueueRowSummaryForWorkflowsSchema: GenMessage<JobQueueRowSummaryForWorkflows> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 6);

/**
 * @generated from message chalk.server.v1.WorkflowGraphNode
 */
export type WorkflowGraphNode = Message<"chalk.server.v1.WorkflowGraphNode"> & {
  /**
   * old fields
   *
   * @generated from field: int32 job_queue_id = 1 [deprecated = true];
   * @deprecated
   */
  jobQueueId: number;

  /**
   * @generated from field: string job_name = 3 [deprecated = true];
   * @deprecated
   */
  jobName: string;

  /**
   * @generated from field: optional int64 job_index = 4 [deprecated = true];
   * @deprecated
   */
  jobIndex?: bigint;

  /**
   * @generated from field: chalk.server.v1.JobQueueState state = 5 [deprecated = true];
   * @deprecated
   */
  state: JobQueueState;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 7 [deprecated = true];
   * @deprecated
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp finalized_at = 8 [deprecated = true];
   * @deprecated
   */
  finalizedAt?: Timestamp;

  /**
   * @generated from field: string operation_id = 2;
   */
  operationId: string;

  /**
   * @generated from field: chalk.server.v1.JobQueueKind kind = 6;
   */
  kind: JobQueueKind;

  /**
   * @generated from field: string resource_group = 9;
   */
  resourceGroup: string;

  /**
   * @generated from field: repeated chalk.server.v1.JobQueueRowSummaryForWorkflows job_queue_row_summaries = 10;
   */
  jobQueueRowSummaries: JobQueueRowSummaryForWorkflows[];
};

/**
 * Describes the message chalk.server.v1.WorkflowGraphNode.
 * Use `create(WorkflowGraphNodeSchema)` to create a new message.
 */
export const WorkflowGraphNodeSchema: GenMessage<WorkflowGraphNode> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 7);

/**
 * @generated from message chalk.server.v1.WorkflowGraphEdge
 */
export type WorkflowGraphEdge = Message<"chalk.server.v1.WorkflowGraphEdge"> & {
  /**
   * @generated from field: string source_operation_id = 1 [deprecated = true];
   * @deprecated
   */
  sourceOperationId: string;

  /**
   * @generated from field: string target_operation_id = 2 [deprecated = true];
   * @deprecated
   */
  targetOperationId: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp satisfied_at = 3;
   */
  satisfiedAt?: Timestamp;

  /**
   * @generated from field: string dependent_operation_id = 4;
   */
  dependentOperationId: string;

  /**
   * @generated from field: string dependency_operation_id = 5;
   */
  dependencyOperationId: string;
};

/**
 * Describes the message chalk.server.v1.WorkflowGraphEdge.
 * Use `create(WorkflowGraphEdgeSchema)` to create a new message.
 */
export const WorkflowGraphEdgeSchema: GenMessage<WorkflowGraphEdge> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 8);

/**
 * @generated from message chalk.server.v1.GetWorkflowGraphResponse
 */
export type GetWorkflowGraphResponse = Message<"chalk.server.v1.GetWorkflowGraphResponse"> & {
  /**
   * @generated from field: repeated chalk.server.v1.WorkflowGraphNode nodes = 1;
   */
  nodes: WorkflowGraphNode[];

  /**
   * @generated from field: repeated chalk.server.v1.WorkflowGraphEdge edges = 2;
   */
  edges: WorkflowGraphEdge[];
};

/**
 * Describes the message chalk.server.v1.GetWorkflowGraphResponse.
 * Use `create(GetWorkflowGraphResponseSchema)` to create a new message.
 */
export const GetWorkflowGraphResponseSchema: GenMessage<GetWorkflowGraphResponse> = /*@__PURE__*/
  messageDesc(file_chalk_server_v1_dataplaneworkflows, 9);

/**
 * @generated from enum chalk.server.v1.WorkflowKind
 */
export enum WorkflowKind {
  /**
   * @generated from enum value: WORKFLOW_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_KIND_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * @generated from enum value: WORKFLOW_KIND_CRON = 2;
   */
  CRON = 2,

  /**
   * @generated from enum value: WORKFLOW_KIND_SCHEDULED_QUERY = 3;
   */
  SCHEDULED_QUERY = 3,
}

/**
 * Describes the enum chalk.server.v1.WorkflowKind.
 */
export const WorkflowKindSchema: GenEnum<WorkflowKind> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_dataplaneworkflows, 0);

/**
 * @generated from enum chalk.server.v1.WorkflowExecutionStatus
 */
export enum WorkflowExecutionStatus {
  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_QUEUED = 1;
   */
  QUEUED = 1,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_WORKING = 2;
   */
  WORKING = 2,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_STATUS_CANCELED = 5;
   */
  CANCELED = 5,
}

/**
 * Describes the enum chalk.server.v1.WorkflowExecutionStatus.
 */
export const WorkflowExecutionStatusSchema: GenEnum<WorkflowExecutionStatus> = /*@__PURE__*/
  enumDesc(file_chalk_server_v1_dataplaneworkflows, 1);

/**
 * @generated from service chalk.server.v1.DataPlaneWorkflowsService
 */
export const DataPlaneWorkflowsService: GenService<{
  /**
   * @generated from rpc chalk.server.v1.DataPlaneWorkflowsService.GetDataPlaneWorkflow
   */
  getDataPlaneWorkflow: {
    methodKind: "unary";
    input: typeof GetDataPlaneWorkflowRequestSchema;
    output: typeof GetDataPlaneWorkflowResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneWorkflowsService.ListDataPlaneWorkflows
   */
  listDataPlaneWorkflows: {
    methodKind: "unary";
    input: typeof ListDataPlaneWorkflowsRequestSchema;
    output: typeof ListDataPlaneWorkflowsResponseSchema;
  },
  /**
   * @generated from rpc chalk.server.v1.DataPlaneWorkflowsService.GetWorkflowGraph
   */
  getWorkflowGraph: {
    methodKind: "unary";
    input: typeof GetWorkflowGraphRequestSchema;
    output: typeof GetWorkflowGraphResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_server_v1_dataplaneworkflows, 0);

